import jsYaml from "js-yaml";
import { EntryProps, FeatureProps, ListTypeForYaml } from "./Types";

export const Ethnicity = {
  featureDetail: {
    name: "codelist",
    displayName: "Clinical Code",
    type: "readCode",
    multiSelect: false,
    isDefaultColumn: true
  },
  entry: {
    isValid: false,
    data: {
      lists: [],
      isMultiSelect: false
    }
  },
  ruleType: "ethnicity",
  featureType: "codelist",
  module: "clinical"
};

/**
 * To get the updated feature details
 * @param entryData component entry data
 * @returns the feature details
 */
export const getUpdatedFeatureDetails = (entryData: EntryProps): FeatureProps => {
  return {
    featureType: Ethnicity.featureType,
    featureDetail: Ethnicity.featureDetail,
    module: Ethnicity.module,
    ruleEntry: {
      ...entryData,
      featureDetail: Ethnicity.featureDetail
    }
  };
};

/**
 * To get the entry data for the edit mode
 * @param definition clint definition
 * @returns the entry data
 */
export const getDataForEdit = (definition: string): EntryProps => {
  if (definition) {
    const parseDefinition: any = jsYaml.load(definition);
    const resources = parseDefinition.resources;
    const lists = resources.map((resource: ListTypeForYaml, index: number) => {
      const resourceName = resource.name;
      return {
        text: resourceName,
        value: resourceName,
        documentText: resourceName,
        id: resource["resource-id"],
        type: !index ? "added" : undefined
      };
    });

    return {
      isValid: true,
      data: {
        isMultiSelect: true,
        lists: lists
      }
    };
  }

  return Ethnicity.entry;
};

export const EthnicityFilters = [
  {
    text: "Ethnicity",
    value: "ETHNICITY"
  },
  {
    text: "Census",
    value: "CENSUS"
  },
  {
    text: "Not given / Refused",
    value: "NOT_GIVEN"
  },
  {
    text: "No record",
    value: "NO_RECORD"
  },
  {
    text: "Unmappable",
    value: "UNMAPPED"
  },
  {
    text: "Not stated",
    value: "NOT_STATED"
  }
];
